import { Directive, ElementRef, input, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appHighlight]',
  standalone: true,
})
export class HighlightDirective {
  searchedWord = input.required<string>();
  text = input.required<string>();
  classToApply = input.required<string>();

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.searchedWord() || !this.classToApply()) {
      this.renderer.setProperty(this.el.nativeElement, 'innerHTML', this.text);
      return;
    }

    this.renderer.setProperty(
      this.el.nativeElement,
      'innerHTML',
      this.getFormattedText(),
    );
  }

  getFormattedText() {
    if (!this.text()) {
      return this.text();
    }

    // Escape special characters in RegExp
    const escapedWord = this.searchedWord().replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    const escapedText = this.text().replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    const re = new RegExp(`(${escapedWord})`, 'gi');
    const res = escapedText.replace(re, `<span class="${this.classToApply()}">$1</span>`);
    return res.replace(/\\/g, '');
  }
}
